import addIcon from "../assets/btn-add-complete.svg";
import deleteIcon from "../assets/btn-delete-complete.svg";
import almacenesIcon from "../assets/almacenes.svg";
import itemsIcon from "../assets/items.svg";
import searchIcon from "../assets/search.svg";
import editIcon from "../assets/icon-edit-white.svg";
import atencionIcon from "../assets/icon-atencion.svg";
import checkIcon from "../assets/icon-check.svg";

export const icons = {
  add: addIcon,
  delete: deleteIcon,
  almacenes: almacenesIcon,
  items: itemsIcon,
  search: searchIcon,
  edit: editIcon,
  atencion: atencionIcon,
  check: checkIcon,
};
